import { render, staticRenderFns } from "./DevPanel.vue?vue&type=template&id=4861cb14"
import script from "./DevPanel.vue?vue&type=script&lang=ts"
export * from "./DevPanel.vue?vue&type=script&lang=ts"
import style0 from "./DevPanel.vue?vue&type=style&index=0&id=4861cb14&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports